import createImageUrlBuilder from "@sanity/image-url";
import { createClient } from "next-sanity";
import useTranslation from "next-translate/useTranslation";
import React from "react";
import FAQ from "SanityComponents/FAQ/FAQ";
import SanityHeadSeo from "../sanity/Components/SanityHeadSeo/SanityHeadSeo";
import Item from "../SanityComponents/CreditImmobilierComponents/ActionElement/Item";
import ItemCard from "../SanityComponents/CreditImmobilierComponents/ActionElement/ItemCard";
import AideCards from "../SanityComponents/CreditImmobilierComponents/AideCards/AideCard";
import CreditImmobilerHeader from "../SanityComponents/CreditImmobilierComponents/CreditImmobilier";
import Footer from "../SanityComponents/Footer/Footer";
import Question from "../SanityComponents/Question/Question";
import Simulez from "../SanityComponents/Simulez/Simulez";
import SubHeader from "../SanityComponents/SubHeader/SubHeader";
import style from "./style.module.css";
import WhatssapComponent from "SanityComponents/WhatssapComponent";
import formatUrl from "utils/FormatUrl";

const client = createClient({
  apiVersion: "2023-01-01",
  dataset: "production" || "production",
  projectId: "n2i0cmq4" || "",
  useCdn: false,
});
function urlFor(source) {
  return createImageUrlBuilder(client).image(source);
}

export function CreditImmobilier({ data }: { data: any | null }) {
  const { t, lang } = useTranslation("common");

  return (
    <div style={{ marginTop: "60px" }}>
      {data?.content.map((item, key) => {
        if (item._type == "lpheader") {
          return (
            <CreditImmobilerHeader
              key={key}
              title={item.titre ? item.titre[lang] : ""}
              subtitle={item.soustitre ? item.soustitre[lang] : ""}
              buttonText={item.button ? item.button[lang] : ""}
              button_link={item.button_link}
              overlay={item.overlay_image}
              content={item.content}
              backgroundUrl={urlFor(item.background_image)
                .format("webp")
                .auto("format")
                .fit("clip")
                .auto("format")
                .toString()}
              lang={lang}
            />
          );
        } else if (item._type == "WhatssapComponent") {
          return (
            <WhatssapComponent
              number={item?.numberPhone ? item.numberPhone : null}
              message={item?.message ? item.message[lang] : null}
            />
          );
        } else if (item._type == "SanityHeadSeo") {
          return (
            <SanityHeadSeo
              key={key}
              title={item.titre ? item.titre[lang] : ""}
              ogTitle={item.titre ? item.titre[lang] : ""}
              description={item.description ? item.description[lang] : ""}
              ogDescription={item.description ? item.description[lang] : ""}
              canonicalUrl={item.canonicalUrl}
              ogTwitterImage={
                item.mainImage
                  ? urlFor(item.mainImage)
                      .width(250)
                      .height(250)
                      .format("webp")
                      .auto("format")
                      .fit("clip")
                      .auto("format")
                      .toString()
                  : null
              }
              ogType={item.ogType}
              ogImageUrl={
                item.mainImage
                  ? urlFor(item.mainImage)
                      .width(250)
                      .height(250)
                      .format("webp")
                      .auto("format")
                      .fit("clip")
                      .auto("format")
                      .toString()
                  : null
              }
              structuredData={null}
            >
              <></>
            </SanityHeadSeo>
          );
        } else if (item._type == "SubHeader") {
          return (
            <SubHeader
              key={key}
              title={item.titre ? item.titre[lang] : ""}
              subTitle={item.subTitle[lang]}
            />
          );
        } else if (item._type == "Faq") {
          return <FAQ data={item} lang={lang} />;
        } else if (item.OffreProComponent?.length === 1) {
          return (
            <div className={style.actionElementFirst}>
              {item.OffreProComponent.map((element, ind) => {
                return (
                  <div key={key}>
                    <Item
                      title={element.titre ? element.titre[lang] : ""}
                      image={urlFor(element.mainImage)
                        .format("webp")
                        .auto("format")
                        .fit("clip")
                        .auto("format")
                        .toString()}
                      width={element.width ? element.width : element.width}
                      height={element.height ? element.height : element.height}
                      description={element.text[lang]}
                      buttonText={element.button_text[lang]}
                      button_link={`https://agenz.ma/${lang}${element.button_link}`}
                      credit={true}
                      lang={lang}
                    />
                  </div>
                );
              })}
            </div>
          );
        } else if (item.OffreProComponent?.length > 1) {
          return (
            <div className={style.actionsContainer}>
              {item.OffreProComponent.map((element, ind) => {
                return (
                  <div key={key}>
                    <ItemCard
                      title={element.titre ? element.titre[lang] : ""}
                      image={urlFor(element.mainImage)
                        .format("webp")
                        .auto("format")
                        .fit("clip")
                        .auto("format")
                        .toString()}
                      width={element.width ? element.width : element.width}
                      height={element.height ? element.height : element.height}
                      description={element.text[lang]}
                      description2={element.text2 ? element.text2[lang] : null}
                      buttonText={element.button_text[lang]}
                      button_link={formatUrl(
                        `https://agenz.ma/${lang}${element.button_link}`,
                        lang
                      )}
                      lang={lang}
                    />
                  </div>
                );
              })}
            </div>
          );
        } else if (item.card) {
          return (
            <>
              {item.card?.AideCards?.length > 0 && (
                <div className={style.cardContainer}>
                  <div className={style.cardTitle}>
                    <p>
                      {item.card?.titre[lang]}
                      {/* Comment pouvons-nous{" "}
                        <span style={{ fontWeight: "500" }}>vous aider</span> ? */}
                    </p>
                  </div>

                  <div className={style.cards}>
                    {item.card?.AideCards?.map((elem, index) => {
                      return (
                        <div key={index}>
                          {elem && (
                            <AideCards
                              title={elem.titre[lang]}
                              subtitle={
                                elem.soustitre ? elem.soustitre[lang] : ""
                              }
                              overlay={elem.overlay_image}
                              content={elem.text[lang]}
                              backgroundUrl={urlFor(elem.mainImage)
                                .format("webp")
                                .auto("format")
                                .fit("clip")
                                .auto("format")
                                .toString()}
                              width={elem.width ? elem.width : elem.width}
                              height={elem.height ? elem.height : elem.height}
                            />
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </>
          );
        } else if (item._type == "QuestionImmobilier") {
          return (
            <div>
              <Question
                title={item.titre ? item.titre[lang] : ""}
                text={item.text ? item.text[lang] : ""}
                buttonText={item.button_text ? item.button_text[lang] : ""}
                image={urlFor(item.mainImage)
                  .format("webp")
                  .auto("format")
                  .fit("clip")
                  .auto("format")
                  .toString()}
                button_link={item.button_link}
              />
            </div>
          );
        } else if (item._type == "SimulezCredit") {
          return (
            <div className={style.simulez}>
              <Simulez
                title={item.titre ? item.titre[lang] : ""}
                buttonText={item.button_text ? item.button_text[lang] : ""}
                button_link={item.button_link}
              />
            </div>
          );
        } else if (item._type == "SanityFooter") {
          return (
            <div className={style.footer}>
              <div className={style.footerDesk}>
                <Footer
                  propos={item.propos[lang]}
                  proposText={item.text ? item.text[lang] : ""}
                  donnee={item.donnees[lang]}
                  donneeText={item.textdonnee[lang]}
                  technologie={item.technologie[lang]}
                  technologieText={item.texttechnologies[lang]}
                  logo={urlFor(item.agenz_logo)
                    .format("webp")
                    .auto("format")
                    .fit("clip")
                    .auto("format")
                    .toString()}
                  facebook={urlFor(item.facebook_logo)
                    .format("webp")
                    .auto("format")
                    .fit("clip")
                    .auto("format")
                    .toString()}
                  instagram_logo={urlFor(item.instagram_logo)
                    .format("webp")
                    .auto("format")
                    .fit("clip")
                    .auto("format")
                    .toString()}
                  linked_in={urlFor(item.linkedin_logo)
                    .format("webp")
                    .auto("format")
                    .fit("clip")
                    .auto("format")
                    .toString()}
                  socialMediaText={item.socialMediatext}
                  copyRightText={item.permission_text}
                />
              </div>
              {/* <div className={style.footerMobile}>
                        <MobileFooter/>
                    </div> */}
            </div>
          );
        } else {
          return null;
        }
      })}
    </div>
  );
}
